<template>
  <div
    class="modal fade"
    id="modalNearExpirePlan"
    ref="modalNearExpirePlan"
    style="z-index: 2000"
    tabindex="2"
    role="dialog"
    aria-labelledby="modalNearExpirePlan"
    data-backdrop="static"
  >
    <div
      class="modal-dialog"
      role="document"
    >
      <!--  ------------------------------- Show plan near expire ----------------------------------------- -->
      <div
        class="modal-content"
      >
        <div class="modal-header bg-warning">
          <h5 class="modal-title">
            <span>
              <i class="fa-solid fa-envelope-open-dollar mr-2" />{{ $t("Subscription Near Expired") }}
            </span>
          </h5>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            @click="closeModal()"
          >
            ×
          </button>
        </div>
        <div class="modal-body">
          <div class=" text-center">
            <div>
              <img
                :src="$storeIndex.getImageSrc('banner-subscription-near-expired')"
                class="mb-3 img-fluid"
                style="width:110px;"
              >
            </div>
            <div class="h4">
              {{ textPlanType }} {{ textExpiresIn }}!
            </div>
            <div>
              {{ textDetail }}
              <br>
              {{ $t("If you feel this is a mistake, contact your admin.") }}
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-center">
          <button
            type="button"
            class="btn btn-outline-warning mr-3"
            data-dismiss="modal"
            @click="okNearExpire()"
          >
            <i class="fa-regular fa-thumbs-up fa-1x mr-1" /> {{ $t('OK') }}
          </button>
          <button
            type="button"
            class="btn btn-warning"
            data-dismiss="modal"
            @click="redirectTo()"
          >
            <i class="fa-solid fa-envelope-open-dollar fa-1x mr-1" /> {{ upgradeButton }}!
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: "ModalNearExpirePlan",
  components: {},
  data() {
    return {
      upgradeButton: this.$t('Renewal Now'),
      textPlanType: this.$t('Plan Subscription Near Expires in'),
      textDetail: this.$t("Click 'Renewal Now' to renew your subscriptions."),
      urlPath: '/app/premium-subscriptions?renewNow=1',
      tenant: JSON.parse(Cookies.get('tenant'))
    };
  },
  mounted() {
    this.checkData();
    this.showModal();

    $(this.$refs.modalNearExpirePlan).on("hidden.bs.modal", () => {
      this.$parent.showNearExpire = false;
    });
  },
  computed: {
    textExpiresIn() {
      let text = '';
      if(this.$parent.planExpiredIn >= 24){
        let daysLeft = this.$parent.planExpiredIn/24;
        text = Math.round(daysLeft) +' '+ this.$t('Days');
      }
      if(this.$parent.planExpiredIn > 0 && this.$parent.planExpiredIn < 24)
      {
        let timesLeft = this.$parent.planExpiredIn;
        text = parseInt(timesLeft).toFixed(0) +' '+ this.$t('hours');
      }
      return text;
    }
  },
  methods: {
    checkData() {
      if(JSON.parse(Cookies.get('plan')).trial){
        this.upgradeButton = this.$t('Upgrade Now');
        this.textPlanType = this.$t('Trial Plan Subscription Near Expires in');
        this.textDetail = this.$t("Click 'Upgrade Now' to upgrade your subscriptions.");
        this.urlPath = '/app/premium-subscriptions/select-plan';
      }
    },
    showModal() {
      setTimeout(() => {
        $('#modalNearExpirePlan').modal('show');
      }, 500);
    },
    okNearExpire() {
      Cookies.set('okNearExpire_'+this.tenant.id, 'true', { domain: '.' + process.env.CENTRAL_API_ROOT, expires: 1  });
      this.closeModal();
    },
    closeModal(){
      this.$parent.showPopUp();
      // this.$store.dispatch("user/showPlanNoti", false);
    },
    redirectTo(){
      try {
        this.$nextTick( () => {
          // this.$router.push({ name: "t.a.premium.subscriptions.select"});
          this.$router.push({ path: this.urlPath});
        });
      } catch (err) {
        console.log(err);
      }
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/layouts/tenancy/admin/ModalNearExpirePlan.vue